import $ from "jquery";

export default function SpinnerLoading(status) {
    let html = `
            <div id="large-loading" class="position-fixed d-flex justify-content-center align-items-center w-100" style="background: rgb(0 0 0 / 29%); top: 0; z-index:9999;height:110vh;bottom: 0;position: fixed;">
                <div class="spinner-loader"></div>
            </div>`;

    if (status) {
        $("body").append(html);
        $("body").attr('style', 'overflow: hidden');
    } else {
        $('#large-loading').remove();
        $("body").removeAttr('style');
    }
}

{/* <section id="unit-kerja">
    <div class="container my-5">
        <div class="row">
            <div class="col">
                <h1 class="f_p f_700 mb_20 w-100 t_color3 text-center titlegradient">
                    Unit Kerja
                </h1>
            </div>
        </div>
        <div class="row justify-content-center">
            <div class="col-12 col-md-6 col-lg-3 mt-3 aos-init aos-animate" data-aos="fade-up" data-aos-delay="100">
                <a target="_blank" href="https://diskominfo.sampangkab.go.id/unit-kerja/kepala-dinas">
                    <div class="card text-center custome pb-4 hover h-100" style="min-height: 400px;">
                        <div class="card-body border-top-primary">
                            <div class="icons-group icon-35px" style="font-size: 40px; margin: 35px; color: rgb(0, 76, 185);">
                                <i class="fas fa-user-tie"></i>
                            </div>
                            <h5 class="card-title pr-0 ml-0 mb-3">KEPALA DINAS</h5>
                            <p class="card-text ml-0" style="padding: 0px 15px;">
                                Mempunyai tugas pokok membantu Bupati dalam menyelenggarakan
                                urusan pemerintahan daerah berdasarkan azas otonomi dan
                                tugas pembantuan di bidang komunikasi, informatika,
                                statistik, dan persandian.
                            </p>
                        </div>
                    </div>
                </a>
            </div>
        </div>
        <div class="row">
            <div class="col-6 col-md-6 col-lg-3 mt-3 sm-h-fitcontent aos-init" data-aos="fade-up" data-aos-delay="200">
                <a target="_blank" href="https://diskominfo.sampangkab.go.id/unit-kerja/Sekretariat">
                    <div class="card text-center custome pb-4 hover h-100 sm-min-h-0 sm-ratio-1 sm-pb-0" style="min-height: 400px;">
                        <div class="card-body border-top-primary">
                            <div class="icons-group icon-35px sm-my-20" style="font-size: 40px; margin: 35px; color: rgb(0, 76, 185);">
                                <i class="fas fas fa-mail-bulk"></i>
                            </div>
                            <h5 class="card-title pr-0 ml-0 mb-3 sm-font-15">SEKRETARIAT</h5>
                            <p class="card-text ml-0 sm-d-none" style="padding: 0px 15px;">
                                Bertugas : Merencanakan, melaksanakan, mengkoordinasikan,
                                dan mengendalikan kegiatan administrasi, kepegawaian,
                                perlengkapan, program, hubungan masyarakat, protokol, dan
                                keuangan.
                            </p>
                        </div>
                    </div>
                </a>
            </div>
            <div class="col-6 col-md-6 col-lg-3 mt-3 sm-h-fitcontent aos-init" data-aos="fade-up" data-aos-delay="300">
                <a target="_blank" href="https://diskominfo.sampangkab.go.id/unit-kerja/IKP">
                    <div class="card text-center custome pb-4 hover h-100 sm-min-h-0 sm-ratio-1 sm-pb-0" style="min-height: 400px;">
                        <div class="card-body border-top-primary">
                            <div class="icons-group icon-35px sm-my-20" style="font-size: 40px; margin: 35px; color: rgb(0, 76, 185);">
                                <i class="fas fas fa-bullhorn"></i>
                            </div>
                            <h5 class="card-title pr-0 ml-0 mb-3 sm-font-15">IKP</h5>
                            <p class="card-text ml-0 sm-d-none" style="padding: 0px 15px;">
                                Bertugas : Merencanakan, melaksanakan, mengkoordinasikan dan
                                mengendalikan pengelolaan layanan Informasi Publik,
                                pengelolaan opini publik, media publik serta kemitraan dan
                                sumber daya komunikasi publik.
                            </p>
                        </div>
                    </div>
                </a>
            </div>
            <div class="col-6 col-md-6 col-lg-3 mt-3 sm-h-fitcontent aos-init" data-aos="fade-up" data-aos-delay="400">
                <a target="_blank" href="https://diskominfo.sampangkab.go.id/unit-kerja/Aptika">
                    <div class="card text-center custome pb-4 hover h-100 sm-min-h-0 sm-ratio-1 sm-pb-0" style="min-height: 400px;">
                        <div class="card-body border-top-primary">
                            <div class="icons-group icon-35px sm-my-20" style="font-size: 40px; margin: 35px; color: rgb(0, 76, 185);">
                                <i class="fas fa-desktop mr-1"></i>
                                <i class="fas fa-mobile-alt"></i>
                            </div>
                            <h5 class="card-title pr-0 ml-0 mb-3 sm-font-15">APTIKA</h5>
                            <p class="card-text ml-0 sm-d-none" style="padding: 0px 15px;">
                                Bertugas : Merencanakan, melaksanakan, mengkoordinasikan dan
                                mengendalikan kegiatan Bidang Aplikasi Informatika.
                            </p>
                        </div>
                    </div>
                </a>
            </div>
            <div class="col-6 col-md-6 col-lg-3 mt-3 sm-h-fitcontent aos-init" data-aos="fade-up" data-aos-delay="500">
                <a target="_blank" href="https://diskominfo.sampangkab.go.id/unit-kerja/SDP">
                    <div class="card text-center custome pb-4 hover h-100 sm-min-h-0 sm-ratio-1 sm-pb-0" style="min-height: 400px;">
                        <div class="card-body border-top-primary">
                            <div class="icons-group icon-35px sm-my-20" style="font-size: 40px; margin: 35px; color: rgb(0, 76, 185);">
                                <i class="fas fas fa-fingerprint mr-1"></i>
                                <i class="fas fa-file-archive"></i>
                            </div>
                            <h5 class="card-title pr-0 ml-0 mb-3 sm-font-15">SDP</h5>
                            <p class="card-text ml-0 sm-d-none" style="padding: 0px 15px;">
                                Bertugas : Merencanakan, melaksanakan, mengkoordinasikan dan
                                mengendalikan Statistik, Persandian dan Pelayanan Informasi
                                dan Dokumentasi.
                            </p>
                        </div>
                    </div>
                </a>
            </div>
        </div>
    </div>
</section> */}
